import { extendTheme } from "@mui/joy/styles";

export const customTheme = extendTheme({
  colorSchemes: {
    dark: {
      palette: {
        mode: "dark",
      },
    },
  },
});
